import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

export function useToastError(error, message = 'Tapahtui virhe!', showOnce = true) {
  const hasShownRef = useRef(false);

  useEffect(() => {
    if (!error) {
      if (showOnce) hasShownRef.current = false;
      return;
    }

    if (!showOnce || !hasShownRef.current) {
      // TODO: tuotantomoodissa ei tarvita tätä jos/kun Sentry käyttöön
      console.error('Error:', error);
      toast.error(message);
      hasShownRef.current = true;
    }
  }, [error, message, showOnce]);
};
